import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '@/components/BottomNav';
import { vendors } from '@/mocks/vendors';
import { categoryData } from '@/mocks/categories';

const filters = [
  { label: '추천순', value: 'recommend' },
  { label: '후기 많은 순', value: 'reviews' },
  { label: '가격순', value: 'price' },
  { label: '가까운 순', value: 'near' },
  { label: '사진 많은 업체', value: 'photos' },
];

export default function Vendors() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<string>('all');
  const [activeFilter, setActiveFilter] = useState('recommend');

  const tabs = [
    { value: 'all', label: '전체' },
    { value: 'dress', label: '예복' },
    { value: 'jewelry', label: '예물' },
    { value: 'hanbok', label: '한복' },
  ];

  const filteredVendors = activeTab === 'all'
    ? vendors
    : vendors.filter((v) => v.category === activeTab);

  return (
    <div className="min-h-[100dvh] bg-cream flex flex-col">
      <div className="sticky top-0 z-40 bg-white border-b border-cream-dark">
        <div className="px-5 pt-6 pb-3">
          <h1 className="text-navy text-xl font-bold">추천 업체</h1>
          <p className="text-beige-dark text-sm mt-1">나의 조건에 맞는 업체를 확인하세요</p>
        </div>

        {/* Category Tabs */}
        <div className="px-5 flex gap-2 pb-3 overflow-x-auto scrollbar-hide">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              onClick={() => setActiveTab(tab.value)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                activeTab === tab.value
                  ? 'bg-navy text-white'
                  : 'bg-cream text-navy border border-cream-dark hover:border-beige'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Filter */}
        <div className="px-5 pb-3 flex gap-2 overflow-x-auto scrollbar-hide">
          {filters.map((f) => (
            <button
              key={f.value}
              onClick={() => setActiveFilter(f.value)}
              className={`px-3 py-1.5 rounded-lg text-xs whitespace-nowrap transition-all cursor-pointer ${
                activeFilter === f.value
                  ? 'bg-navy text-white'
                  : 'bg-white text-gray-500 border border-cream-dark hover:border-beige'
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-5 py-4">
        <div className="space-y-4">
          {filteredVendors.map((vendor) => {
            const cat = categoryData[vendor.category as keyof typeof categoryData];
            return (
              <button
                key={vendor.id}
                onClick={() => navigate(`/vendor/${vendor.id}`)}
                className="w-full bg-white rounded-2xl border border-cream-dark overflow-hidden text-left cursor-pointer hover:shadow-sm transition-shadow"
              >
                <div className="flex">
                  <div className="w-[120px] h-[140px] shrink-0 overflow-hidden">
                    <img
                      src={vendor.image}
                      alt={vendor.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 p-4 min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <div className="min-w-0">
                        <p className="font-semibold text-navy text-sm truncate">{vendor.name}</p>
                        <p className="text-beige-dark text-xs mt-0.5">{vendor.region}</p>
                      </div>
                      <span
                        className="px-2 py-0.5 rounded text-[10px] font-medium shrink-0"
                        style={{ backgroundColor: `${cat.color}12`, color: cat.color }}
                      >
                        {cat.name}
                      </span>
                    </div>
                    <p className="text-navy text-sm font-medium mt-2">{vendor.priceRange}</p>
                    <div className="flex items-center gap-1 mt-1.5 text-beige-dark text-xs">
                      <i className="ri-star-fill text-softgold text-xs" />
                      <span>후기 {vendor.reviewCount}</span>
                      <span className="mx-1">·</span>
                      <span>사진 {vendor.photoReviewCount}</span>
                    </div>
                    <div className="flex flex-wrap gap-1 mt-2">
                      {vendor.tags.slice(0, 2).map((tag) => (
                        <span
                          key={tag}
                          className="px-2 py-0.5 rounded bg-cream text-navy text-[10px] font-medium border border-cream-dark"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="px-4 py-3 border-t border-cream-dark flex gap-2">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate('/quote');
                    }}
                    className="flex-1 bg-navy text-white rounded-lg py-2 text-xs font-medium cursor-pointer hover:bg-navy-light transition-colors whitespace-nowrap"
                  >
                    견적 요청
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className="px-4 py-2 bg-cream text-navy rounded-lg text-xs font-medium border border-cream-dark cursor-pointer hover:bg-cream-dark transition-colors whitespace-nowrap"
                  >
                    비교 담기
                  </button>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}